import { TFunction } from 'i18next';
import { StepStructure } from 'common/components';

export const CEILINGS_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/natyazhnye-potolki-na-zakaz/';

export const CEILINGS_ELEMENT_BLOCK = 'landingPotolkiNaZakaz';

export const CEILINGS_LANDING_NAME = 'ceilings';

export const SERVICE_ID = '1527';

export const CEILINGS_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/ceilings';

export const getCeilingsStepsList = (t: TFunction): StepStructure[] => [
  {
    title: t('steps-section.first.title'),
    description: t('steps-section.first.description'),
  },
  {
    title: t('steps-section.second.title'),
    description: t('steps-section.second.description'),
  },
  {
    title: t('steps-section.third.title'),
    description: t('steps-section.third.description'),
  },
  {
    title: t('steps-section.fourth.title'),
    description: t('steps-section.fourth.description'),
  },
];
